import { Injectable } from "@angular/core";
import { AppConfig } from "../app.config";
import { HttpClient } from "@angular/common/http";
import {
  CompressionHelper,
  CompressedResult,
} from "../helpers/compression.helper";
import { StatusService } from "./status.service";
import { UserdataDTO } from "../models/UserdataSync";
import { UsuarioGuiasService } from "./data-services/usuario.guias.service";
// azure card 358 Desativar botão caiu em prova
import { UsuarioProvasService } from "./data-services/usuario.provas.service";
import { UsuarioMarcacoesService } from "./data-services/usuario.marcacoes.service";
import { UsuarioEstatisticasService } from "./data-services/usuario.estatisticas.service";
import { UsuarioApontamentosService } from "./data-services/usuario.apontamentos.service";
import { UsuarioPreferenciasService } from "./data-services/usuario.preferencias.service";
import { SignalrService } from "./signalr.service";
import { LeiRepositorio } from "../repositorios/lei.repositorio";
import { ErrorHandlerService } from "./errorHandler.service";
import { AssinaturaService } from "../modules/shared/services/assinatura.service";
import { first, firstValueFrom } from "rxjs";

@Injectable()
export class DadosService {
  public taskName = "baixar-leis";
  public url = `${AppConfig.apiEndpoint}/sync`;

  constructor(
    private statusService: StatusService,
    private usuarioGuiasService: UsuarioGuiasService,
    // azure card 358 Desativar botão caiu em prova
    private usuarioProvasService: UsuarioProvasService,
    private usuarioMarcacoesService: UsuarioMarcacoesService,
    private usuarioEstatisticasService: UsuarioEstatisticasService,
    private usuarioApontamentosService: UsuarioApontamentosService,
    private usuarioPreferenciasService: UsuarioPreferenciasService,
    private leiRepositorio: LeiRepositorio,
    private signalrService: SignalrService,
    private errorHandlerService: ErrorHandlerService,
    private httpClient: HttpClient,
    private assinaturaService: AssinaturaService
  ) {}

  public async baixar(): Promise<void> {
    await this.baixarTudo();
  }

  public async processarDadosBaixados(json: string): Promise<void> {
    try {
      this.statusService.mostrarMensagemProgresso(
        "Salvando informações",
        this.taskName
      );

      const userdata = <UserdataDTO>JSON.parse(json);

      // azure card 358 Desativar botão caiu em prova
      this.statusService.mostrarMensagemProgresso(
        "Processando base de provas",
        this.taskName
      );
      await this.usuarioProvasService.fromNuvem(userdata.provaDatasource);

      this.statusService.mostrarMensagemProgresso(
        "Processando guias",
        this.taskName
      );
      await this.usuarioGuiasService.fromNuvem(userdata.guias);
      this.usuarioGuiasService.carregar();

      this.statusService.mostrarMensagemProgresso(
        "Processando marcações de prova",
        this.taskName
      );
      await this.usuarioMarcacoesService.fromNuvem(userdata.marcacoesProva);

      this.statusService.mostrarMensagemProgresso(
        "Processando comentários",
        this.taskName
      );

      this.statusService.mostrarMensagemProgresso(
        "Processando referências",
        this.taskName
      );

      this.statusService.mostrarMensagemProgresso(
        "Processando marca-textos",
        this.taskName
      );

      this.statusService.mostrarMensagemProgresso(
        "Processando estatísticas de leitura",
        this.taskName
      );
      await this.usuarioEstatisticasService.fromNuvem(
        userdata.estatisticasLeitura
      );

      this.statusService.mostrarMensagemProgresso(
        "Processando apontamentos",
        this.taskName
      );
      await this.usuarioApontamentosService.fromNuvem(userdata.apontamentos);

      this.statusService.mostrarMensagemProgresso(
        "Processando configurações",
        this.taskName
      );
      this.usuarioPreferenciasService.fromNuvem(userdata);
    } catch (error) {
      this.errorHandlerService.handleError(error);
    }
  }

  public async atualizarComponentes(): Promise<void> {
    const tasks = new Array<Promise<void>>();

    tasks.push(this.usuarioGuiasService.carregar());

    try {
      await Promise.all(tasks);
    } catch (error) {
      this.errorHandlerService.handleError(error);
    }
  }

  public async baixarTudo(): Promise<void> {
    try {
      await this.leiRepositorio.atualizarLista();

      const syncResult = <CompressedResult>(
        await firstValueFrom(this.httpClient.get(this.url).pipe(first()))
      );
      const data = CompressionHelper.unzip(syncResult);

      await this.processarDadosBaixados(data);
      this.statusService.mostrarMensagemProgresso(
        "Iniciando serviço de sincronização",
        this.taskName
      );

      await this.signalrService.conectar();

      this.statusService.setDataUltimaAtualizacao(new Date());
      await this.atualizarComponentes();
    } catch (error) {
      this.errorHandlerService.handleError(error);
    } finally {
      this.statusService.ocultarMensagemProgresso(this.taskName);
    }
  }
}
